import { render, staticRenderFns } from "./SharePhotosd.vue?vue&type=template&id=2f520f24&"
import script from "./SharePhotosd.vue?vue&type=script&lang=js&"
export * from "./SharePhotosd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports